<template>
    <div>
        <span title="More information" v-on:click="aboutPage = true" class="about">
            <font-awesome-icon icon="info"/>
        </span>
      <transition name="fade">
        <div v-if="aboutPage" v-on:click.self="aboutPage = false" class="aboutPage">
          <div class="aboutPage-content">
            <span v-on:click="aboutPage = false" style="float: right"> <font-awesome-icon icon="times"/></span>
            <h1>Southeast Michigan Building Footprints</h1>
            <p>SEMCOG’s building footprint data layer represents the digital footprint of each building in Southeast
              Michigan,
              as of April 2020, along with associated attributes of each building.</p>
            <h3>Instructions</h3>
            <p>Zoom into the map and click on a Building Footprint to display details about a building. Click and hold on the compass button
            <span class="mapboxgl-ctrl">
              <button class="mapboxgl-ctrl-compass" style="height: 25px; width: 25px;" type="button" title="Reset bearing to north"
                      aria-label="Reset bearing to north"><span class="mapboxgl-ctrl-icon" aria-hidden="true"
                                                                style="transform: scale(1.39341) rotateX(59deg) rotateZ(40.1deg);"></span>
              </button>
            </span>
             in the lower left corner or hold the ctrl key to pan in 3D. There is also a
              link on
              the building popup window to email SEMCOG staff if you have questions about a building or updated
              information. </p>

            <p>Download the building footprint data used in this map from our open data portal
              <a href="https://maps-semcog.opendata.arcgis.com/datasets/SEMCOG::building-footprints-2020/explore"
                 target="_blank">
                here.</a></p>

            <p> A description of SEMCOG building types as well as all other attributes can be found in
              <a href="./Buildings_Documentation_062420.pdf" target="_blank">
                SEMCOG’s Building Footprints documentation.</a>
              For more information contact
              <a href="mailto:InfoCenter@semcog.org?subject=Building Footprints Question">SEMCOG</a>.
            </p>
          </div>
        </div>
      </transition>

    </div>

</template>

<script>
    export default {
        name: "AboutPage",
        data: function () {
            return {
                aboutPage: false,
            }
        },
    }
</script>

<style scoped>

    .about {
        float: right;
        padding: 5px;
    }

    .aboutPage {
        position: fixed;
        background: rgba(46, 60, 67, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        opacity: 1;
        overflow: hidden;
    }

    .aboutPage-content {
        background: white;
        max-width: 80%;
        border: #fffcfc solid 2px;
        border-radius: 10px;
        padding: 10px 30px;
        max-height: 80%;
        overflow: auto;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter, .fade-leave-to
    {
        opacity: 0;
    }

    .fade-enter-active .aboutPage-content, .fade-leave-active .aboutPage-content {
        transition: transform 1s;
    }

    .fade-enter .aboutPage-content, .fade-leave-to .aboutPage-content {
        transform: translate(-50vw, -50vh) scale(0);
    }

    .fade-enter-to .aboutPage-content, .fade-leave-to .aboutPage-content {
        overflow: hidden;
    }

</style>
